import React, { useContext } from 'react'

import ToastContext from '../../context/Toast'

import './TestPaymentInfo.scss'

/**
 * Component that displays a ton of different stripe test cards - to help make testing easy :) 
 *
 * @component
 * @example
 * return (
 *   <TestPaymentInfo />
 * )
*/

const TestPaymentInfo = () => {

    const { setToast } = useContext(ToastContext)

    const handleCardClicked = evt => {
        navigator.clipboard.writeText(evt.target.querySelector('.test-card-number').innerText)
        setToast('Card number copied to clipboard!')
    }

    return (
        <div id="test-payment-info">
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the successful visa test card: <span className="text-success test-card-number pe-none">4242424242424242</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the successful visa debit test card: <span className="text-success test-card-number pe-none">4000056655665556</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the successful mastercard test card: <span className="text-success test-card-number pe-none">5555555555554444</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the successful amex test card: <span className="text-success test-card-number pe-none">378282246310005</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the successful discover card test card: <span className="text-success test-card-number pe-none">6011111111111117</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the "card_declined" test card: <span className="text-danger test-card-number pe-none">4000000000000002</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the "expired_card" test card: <span className="text-danger test-card-number pe-none">4000000000000069</span></p> </div>
            <div className="text-center test-payment-card"onClick={handleCardClicked}> <p className="pe-none">Try the test card that requires SCA: <span className="text-success test-card-number pe-none">4000002500003155</span></p> </div>
            <div className="text-center"> <p>Use any <i>future</i> expiry date, CVC, and 5 digit postal code.</p> </div>
        </div>
    );

}

export default TestPaymentInfo